import {
  LOAN_APPLICATION_UPDATE_FAILURE,
  UPDATE_FINANCIALS_FAILURE,
  UPDATE_INCOME_FAILURE,
  UPDATE_EXPENSE_FAILURE,
  UPDATE_PROFILE_FAILURE,
  LOAN_APPLICATION_USER_VERIFY_FAILURE,
} from './../actions/types'

const errors = (state={}, {type, payload}) => {
  switch(type) {
    case LOAN_APPLICATION_UPDATE_FAILURE:
      return payload
    case UPDATE_FINANCIALS_FAILURE:
    case UPDATE_INCOME_FAILURE:
    case UPDATE_EXPENSE_FAILURE:
    case UPDATE_PROFILE_FAILURE:
    case LOAN_APPLICATION_USER_VERIFY_FAILURE:
      return payload.errors || {}

    default:
      return {}
  }
}

export const getErrorMessage = (state) => (state)

export default errors;
